/** W92 (D-1352, Nachtrag D-1354): Texte der Kurzstufe im Blatt „Brief zur Verbesserung freigeben“ an einer Stelle, wortgleich mit
 *  `plan-w92.md` Abschnitt 3 und iOS `FreigabeKurztext` (NF-30). Zeile 2 traegt den Link auf Abschnitt 5a der
 *  Datenschutzerklaerung; Zeile 3 (Art. 9 DSGVO, F1 = A) haengt am Schalter `MIT_ART9`, der nach dem Entscheid an bleibt. */

/** F1 = A (Nachtrag D-1354): die dritte Zeile mit der ausdruecklichen Einwilligung fuer Angaben zur Gesundheit steht immer da. */
export const MIT_ART9 = true;

/** Ziel des Links „Datenschutzerklärung“ (Abschnitt 5a, `id: "freigabe"` in `rechtliches/texte.ts`). */
export const FREIGABE_DATENSCHUTZ = "/datenschutz#freigabe";

/** Fassung der Einwilligung, die das Web bei jeder Einzelfreigabe schickt (W92-S `KURZ_FASSUNG`, Nachtrag D-1362 Punkt 16):
 *  fest, nie die Fassung aus der Vorschau-Antwort. */
export const FREIGABE_FASSUNG = "2026-10-28.1";

const ZEILE_3 = "Der Brief kann Angaben zur Gesundheit enthalten. Mit dem Freigeben willigst du ausdrücklich ein, dass wir auch sie dafür nutzen.";

/** Absaetze der Kurzstufe; `link` ist der Teil von Zeile 2, der auf `FREIGABE_DATENSCHUTZ` zeigt. */
export const FREIGABE_KURZ: { vor: string; link?: string; nach?: string }[] = [
  { vor: "Wir bekommen den geschwärzten Text und die Einordnung, kein Bild." },
  { vor: "Freiwillig, jederzeit widerrufbar. Mehr in der ", link: "Datenschutzerklärung", nach: "." },
  ...(MIT_ART9 ? [{ vor: ZEILE_3 }] : []),
];

/** Knopftexte der Kurzstufe in ihrer Reihenfolge (Hauptknopf zuerst) und das Notizfeld (Nachtrag D-1354 Punkt 3, D-1362 Punkt 15). */
export const FREIGABE_KNOEPFE = { vorher: "Vorher ansehen", freigeben: "Freigeben", mitFeedback: "Mit Feedback freigeben" } as const;

export const NOTIZ = {
  label: "Notiz zum Brief",
  platzhalter: "Zum Beispiel: Die Frist wurde nicht erkannt.",
  hinweis: "Wir schwärzen Namen und Nummern auch in deiner Notiz.",
  hoechstens: 500,
  zaehler: (n: number) => `${n} von 500`,
} as const;

/** W82 Web-8 W8-4 (S93 F4 = A, D-1472; WN-108): Hinweis vor „Alle freigeben“ (Wahl „Alle meine Briefe“), wortgleich mit iOS
 *  `EinwilligungBlatt.ohneVorschau` (NO-1); ergänzende Bedieninformation, nicht Teil des Einwilligungstexts des Servers. */
export const ALLE_OHNE_VORSCHAU =
  "Die geschwärzten Kopien entstehen beim Ablegen, ohne dass du sie vorher siehst. Du kannst die Wahl jederzeit in den Einstellungen unter „Freigegebene Briefe“ zurücknehmen.";

/** Statuszeile der Kurzstufe, solange die Vorschau beim Oeffnen laeuft. */
export const FREIGABE_VORBEREITET = "Wird vorbereitet …";
